import * as React from "react"
import styled from "styled-components"
import {GatsbyImage, getImage, StaticImage} from "gatsby-plugin-image"
import breakpoints from "../../styles/breakpoints";
import fonts from "../../styles/fonts";
import colors from "../../styles/colors";
import {renderRichText} from "gatsby-source-contentful/rich-text";

const TextImageContainer = styled.div`
  margin-bottom: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  position: relative;

  @media (min-width: ${breakpoints.lg}) {
    flex-direction: ${(props) => props.left ? "row-reverse" : "row"};
    width: 100%;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  max-width: 360px;
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 0;
  position: relative;
  
  p {
    font-size: 17px;
    line-height: 27px;
    margin-bottom: 40px;
  }
  
  h2 {
    // ${fonts.gloryBold};
    // font-size: 24px;
    // line-height: 40px;
    // margin-bottom: 20px;

    ${fonts.gloryBold};
    font-size: 48px;
    line-height: 54px;
    margin-bottom: 32px;

    @media (min-width: ${breakpoints.lg}) {
      font-size: 72px;
      line-height: 72px;
    }
  }
  
  h3 {
    ${fonts.gloryBold};
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 20px;
  }
  
  a {
    color: ${colors.white};
    text-decoration: none;
    padding-bottom: 2px solid ${colors.white};
    border-bottom: 1px solid ${colors.white};
    cursor: pointer;
  
    &:hover {
      color: ${colors.blue};
      border-color: ${colors.blue};
    }
  }

  @media (min-width: ${breakpoints.lg}) {
    margin-right: ${(props) => props.left ? "0" : "120px"};
    margin-left: ${(props) => props.left ? "120px" : "0"};
    margin-bottom: 0;
  }
`;

const ImageContainer = styled.div`
  width: 320px;
  height: 320px;
  position: relative;

  .gatsby-image-wrapper {
    width: 100% !important;
    height: 100% !important;

    > div {
      height: 100%;
    }
  }

  @media (min-width: ${breakpoints.lg}) {
    width: 464px;
    height: 464px;
  }
`;

const StyledArticleImage = styled(GatsbyImage)`
  display: block !important;
  width: 100%;
  height: 100%;
`

const TextImage = ({image, content, position}) => {
  const isLeft = position === true;

  return (
    <TextImageContainer left={isLeft}>
      <TextContainer left={isLeft}>
        {renderRichText(content)}
      </TextContainer>
      <ImageContainer>
        <StyledArticleImage image={getImage(image)} loading={"lazy"} objectFit={"contain"} />
      </ImageContainer>
    </TextImageContainer>
  )
}

export default TextImage;
